<template>
  <div :class="$style.container">
    <!-- step === 0 -->
    <template v-if="step === 0">
      <Item title="请填写您要转出的域名">
        <el-input
          v-model="domainName"
          placeholder="请填写您要转出的域名"
        ></el-input>
      </Item>

      <Item title=" ">
        <Button type="primary" :loading="loading" @click="submit">
          下一步
        </Button>
      </Item>

      <div :class="$style.explain">
        <p :class="$style.explain_title">域名转出条件</p>
        <ul>
          <template v-for="(item, index) in explain">
            <li :class="$style.explain_text" :key="index">{{ item }}</li>
          </template>
          <li>
            <AgreementPopup :title="agreeTitle" :content="agreeContent" />
          </li>
        </ul>
      </div>
    </template>

    <!-- step !== 1 -->
    <template v-else>
      <p :class="$style.top_tip">
        {{
          step === 1 || step === 2
            ? "tips：国际域名续费60天内转入到新注册商，可能会产生“续费掉年”现象，请谨慎操作!"
            : "tips：转移码的有效期15天，请在有效期内办理域名转移业务!"
        }}
      </p>
      <Step :data="stepList" :step="step" size="small" />

      <div v-if="step === 1" :class="$style.step_wrap">
        <p :class="$style.step_tip">
          为了保障您的域名安全，我们需要验证您的信息
        </p>
        <Item :title="checkType === 0 ? '手机号：' : '邮箱：'">
          <span>
            <span>{{ checkType === 0 ? mobile : userInfo.email }}</span>
            <template v-if="checkType === 0 && userInfo.email && userInfo.email.length > 0">
              <el-button type="text" :disabled="captchaBtnSending" @click="checkTypeMethod(1)" style="color: #ff5c35; margin-left: 10px;">邮箱验证</el-button>
            </template>
            <template v-if="checkType === 1 && userInfo.mobile && userInfo.mobile.length > 0">
              <el-button type="text" :disabled="captchaBtnSending" @click="checkTypeMethod(0)" style="color: #ff5c35; margin-left: 10px;">手机号码验证</el-button>
            </template>
          </span>
        </Item>
        <Item title="验证码：">
          <el-input
            v-model="code"
            placeholder="请输入验证码"
            maxlength="6"
            style="width: 120px"
            @input="code = code.replace(/[^\d]/g, '')"
          />
          <CaptchaButton ref="captchaButton" :checkType="checkType" />
        </Item>
        <Item title=" ">
          <Button type="primary" :loading="loading" @click="step1Submit">
            下一步
          </Button>
          <Button type="primary2" @click="goBack">返回</Button>
        </Item>
      </div>

      <div v-if="step === 2" :class="$style.step_wrap">
        <p :class="$style.step_tip">
          为了保障您的域名安全，请确认您要转出的域名，以及转移码接收邮箱
        </p>
        <Item title="转出的域名：">
          <span> {{ domainName }} </span>
        </Item>
        <Item title="转移码接收邮箱：">
          <span> {{ email }} </span>
        </Item>
        <Item title=" ">
          <Button type="primary" :loading="loading" @click="step2Submit">
            获取转移码
          </Button>
          <Button type="primary2" @click="goBack">返回</Button>
        </Item>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { verifyDomain, transferVerifyCode, createTransferCode } from "@server";
import { DOMAIN_OUT_TIPS } from "@constant";
import CaptchaButton from "../../../components/CaptchaButton.vue";
import AgreementPopup from "@components/AgreementPopup.vue";
import transferRules from "@constant/transferOutRules.js";

export default {
  components: { CaptchaButton, AgreementPopup },
  name: "DomainNine",
  data() {
    return {
      explain: DOMAIN_OUT_TIPS,
      loading: false,

      step: 0,
      stepList: ["验证手机", "核对邮箱", "等待邮件确认", "域名转出成功"],

      domainName: "",
      email: "",
      mobile: "",
      verifyCode: "",

      code: "", // 获取验证码数据
      getCodeAvailable: true, // 是否可以获取验证码
      getCodeContent: "获取验证码", // 获取验证码按钮上的文字
      getCodeInterval: null, // 获取验证码定时器,
      agreeTitle: transferRules.title,
      agreeContent: transferRules.content,

      checkType: 0,
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
    captchaBtnSending() {
      return this.$refs.captchaButton && this.$refs.captchaButton.countdown > 0;
    },
  },
  methods: {
    checkTypeMethod(type) {
      if (this.captchaBtnSending) return;
      this.checkType = type;
      this.$refs.captchaButton.reset();
    },

    // 提交验证域名
    async submit() {
      if (!this.domainName) {
        this.$message({ message: "请输入您要转出的域名！", type: "warning" });
        return;
      }

      this.loading = true;
      const res = await verifyDomain({ domainName: this.domainName });

      if (res.code == 200) {
        this.domainName = res.data.domainName;
        this.mobile = res.data.phone;
        this.verifyCode = res.data.code;
        // 初始化checkType: 优先手机验证
        if (this.userInfo.mobile != null && this.userInfo.mobile.length > 0) {
          this.checkType = 0;
        } else {
          this.checkType = 1;
        }
        this.step = 1;
        this.$nextTick(() => {
          this.$refs.captchaButton.handleClick();
        });
      } else {
        this.$message({ message: res.message, type: "warning" });
      }
      this.loading = false;
    },

    // 提交step1 - 进行手机验证码验证
    async step1Submit() {
      if (!this.verifyCode) {
        this.$message({ message: "没有权限进行此次操作!", type: "warning" });
        return;
      }
      if (!this.code) {
        this.$message({ message: "请输入验证码!", type: "warning" });
        return;
      }

      this.loading = true;
      const data = {
        msgCode: this.code,
        verifyCode: this.verifyCode,
        type: this.checkType,
      };
      const res = await transferVerifyCode(data);

      if (res.code == 200) {
        this.domainName = res.data.domainName;
        this.email = res.data.email;
        this.verifyCode = res.data.code;
        this.step = 2;
      }
      this.loading = false;
    },

    // 提交step2 - 创建转移码
    async step2Submit() {
      if (!this.verifyCode) {
        this.$message({ message: "没有权限进行此次操作！", type: "warning" });
        return;
      }

      this.loading = true;
      const params = {
        verifyCode: this.verifyCode,
      };
      const res = await createTransferCode(params);

      if (res.code === 200) {
        this.$message({
          message:
            "域名转出申请已经提交，请等待我司域名转移专员为您人工审核处理!",
          type: "success",
        });
        this.$router.replace("/user/domain-out?activeName=second");
      }
      this.loading = false;
    },

    goBack() {
      this.checkType = 0;
      this.step = 0;
      this.domainName = "";
      this.email = "";
      this.mobile = "";
      this.verifyCode = "";
      this.code = "";
      if (this.$refs.captchaButton) {
        this.$refs.captchaButton.reset();
      }
    },
  },
};
</script>

<style lang="scss" module scoped>
.container {
  min-height: 360px;
  font-size: 14px;
  color: #333;

  :global {
    ::v-deep .gl-item {
      margin-bottom: rem(30);
      .gl-item__left {
        width: rem(200);
      }
    }

    .el-input {
      width: rem(360);
    }
  }

  .explain {
    padding: rem(20);

    .explain_title {
      font-size: max(rem(18), 16px);
      font-weight: bold;
      color: #333333;
      line-height: rem(60);
    }

    ul {
      padding-left: 20px;
      padding-right: 50px;
    }

    .explain_text {
      font-size: 14px;
      transition: color 0.3s;
      color: rgba(61, 61, 61, 0.8);
      line-height: 28px;

      &:last-child,
      &:hover {
        color: $theme-color;
      }
    }
  }

  .top_tip {
    padding: 20px 30px;
    margin-bottom: 12px;
    background-color: #f4f4f7;
  }

  .step_wrap {
    margin-top: rem(20);
    margin-left: 180px;

    :global {
      ::v-deep .gl-item {
        margin-bottom: 30px;
        .gl-item__left {
          width: auto;
        }
      }
    }

    .step_tip {
      margin-bottom: rem(30);
    }
  }
}
::v-deep .gl-item__left {
  display: none!important;
}
</style>
